import { useMutation, useQueryClient } from '@tanstack/react-query';

import { withError, withInvalidate } from '@/react-tools/react-query';
import { getAllSettledItems } from '@/portainer/helpers/promise-utils';

import { TeamId } from '../types';

import { updateTeam } from './useUpdateTeamMutation';
import { teamQueryKeys } from './query-keys';

interface TeamDenyPortainerAccessUpdate {
  id: TeamId;
  denyPortainerAccess: boolean;
}

interface ApplyPayload {
  updates: TeamDenyPortainerAccessUpdate[];
}

/** Sets DenyPortainerAccess on every given team, each to its own value. */
export function useApplyDenyPortainerAccessMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applyDenyPortainerAccess,
    ...withError('Failed to update team add-on restriction'),
    ...withInvalidate(queryClient, [teamQueryKeys.base()]),
  });
}

async function applyDenyPortainerAccess({ updates }: ApplyPayload) {
  // allSettled: every team is attempted, and a partial failure is reported in
  // full rather than only the first rejection.
  const { rejectedItems } = await getAllSettledItems(updates, (update) =>
    updateTeam(update)
  );

  if (rejectedItems.length > 0) {
    throw new Error(
      `${rejectedItems.length} of ${updates.length} teams could not be updated: ${rejectedItems
        .map(({ reason }) => reason)
        .join(', ')}`
    );
  }
}
